const { same } = require('../utils');

exports.computeMainAxisFromTables = tables => same(tables, 'mainAxis', 'vertical');
